import { Component, inject, OnInit } from '@angular/core';
import { NgForOf, NgIf } from "@angular/common";
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-produce-program',
    imports: [
        NgForOf,
        NgIf
    ],
    templateUrl: './produce-program.component.html',
    styleUrl: './produce-program.component.scss'
})
export class ProduceProgramComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title)
  lowCostSteps = [
    {
      num: '1',
      title: 'Identify a group of 50 households that value local, nutritious food.',
      arrow: true
    },
    {
      num: '2',
      title: 'Work with our team to build the contents of your box and work out delivery logistics.',
      arrow: true
    },
    {
      num: '3',
      title: 'Place your orders on the frequency you choose.',
      arrow: true
    },
    {
      num: '4',
      title: 'Enjoy good food with family, friends and members of your community.',
      arrow: false
    },
  ]

  ngOnInit(): void {
    this.setUpSEOTags();
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/how-it-works/produce-program'
    const component = 'Low Cost Produce'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }


}
